import React, { Fragment, Suspense } from 'react'
import { Route, Routes } from 'react-router'

export interface RouteRow {
  key?: string
  isIndex: boolean
  path: string // 页面网址路由
  route: string // 页面路径
  lazy: boolean
  component: JSX.Element
}

interface P {
  routes: RouteRow[]
}

const App = (props: P) => {
  const { routes } = props
  return (
    <Routes>
      {routes.map((item, index) => {
        const LazyComp = React.lazy(
          () =>
            import(
              /* @vite-ignore */
              item.route
            )
        )
        return (
          <Route
            caseSensitive
            path={item.path}
            key={item.key || index.toString()}
            index={item.isIndex}
            element={
              item.lazy ? (
                <Suspense fallback={'<div>...</div>'}>
                  <LazyComp />
                </Suspense>
              ) : (
                <Fragment>{item.component}</Fragment>
              )
            }
          />
        )
      })}

      {/* "No Match" Route */}
      <Route
        path="*"
        element={
          <div style={{ padding: '1rem', fontSize: 20, textAlign: 'center' }}>
            <p>{'null'}</p>
          </div>
        }
      />
    </Routes>
  )
}

export default App
